/**
 * Tutorial guidato di Impostazioni → Pubblicità: elenco delle piattaforme come le altre impostazioni dei servizi.
 * La prima riga (Google Ads) si apre e si richiude da sola; `stopAdsSettingsTour` la richiude se il giro si interrompe.
 */
const SCOPE = '[data-tour-scope="setting-ads"]';

const at = name => `${SCOPE} [data-tour="${name}"]`;

const wait = () => new Promise(resolve => setTimeout(resolve, 300));

let aperta = false;

async function apriPrima(open) {
	const btn = document.querySelector(at('expand'));
	const isOpen = !!document.querySelector(at('settings'));
	if (btn && isOpen !== open) {
		aperta = open;
		btn.click();
		await wait();
	}
}

export function stopAdsSettingsTour() {
	if (aperta) apriPrima(false);
	aperta = false;
}

export function createAdsSettingsTourSteps() {
	return [
		{
			body: 'Qui colleghi le piattaforme pubblicitarie: Azseller legge ogni notte la spesa delle campagne e la usa nel report Pubblicità, nella Home e nel conto economico.',
			key: 'intro',
			placement: 'bottom',
			target: at('tutorial'),
			title: 'Piattaforme pubblicitarie',
		},
		{
			before: () => apriPrima(false),
			body: 'L’interruttore accende la lettura della spesa. Alla prima attivazione Azseller legge anche gli ultimi 13 mesi, poi ogni notte rilegge gli ultimi 30 giorni.',
			key: 'table',
			placement: 'bottom',
			target: at('table'),
			title: 'Attivare una piattaforma',
		},
		{
			before: () => apriPrima(true),
			body: 'Dal + apri le impostazioni: come collegarla, se usare la spesa nel conto economico, l’esito dell’ultima lettura e «Leggi adesso».',
			key: 'settings',
			missing: 'skip',
			placement: 'top',
			target: at('settings'),
			title: 'Impostazioni della piattaforma',
		},
	];
}
